import api from './api';

export const getProjectActivityReviews = async (
  projectId,
  { status = 'pending', limit = 100, offset = 0 } = {},
) => {
  const response = await api.get(`/projects/${projectId}/activity-reviews`, {
    params: { status, limit, offset },
  });
  return response.data;
};

export const getActivityReview = async (chainId) => {
  const response = await api.get(`/activity-reviews/${chainId}`);
  return response.data;
};

export const updateActivityReview = async (chainId, payload) => {
  const response = await api.put(`/activity-reviews/${chainId}`, payload);
  return response.data;
};

export const getUnassignedActivityReviews = async ({ limit = 100, offset = 0 } = {}) => {
  const response = await api.get('/activity-reviews/unassigned', { params: { limit, offset } });
  return response.data;
};

export const updateActivityProject = async (chainId, payload) => {
  const response = await api.put(`/activity-reviews/${chainId}/project`, payload);
  return response.data;
};

export const getActivityProjectAssignmentQuality = async () => {
  const response = await api.get('/activity-reviews/project-assignment/quality');
  return response.data.quality || response.data;
};

export const getProjectActivityReviewStats = async (projectId, { from, to } = {}) => {
  const response = await api.get(`/projects/${projectId}/activity-reviews/stats`, {
    params: from && to ? { from, to } : {},
  });
  return response.data.stats || response.data;
};
